import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { BrandMark } from '@/components/BrandMark/BrandMark'
import { Routes } from '@/utils/navigation/routes'
import { rememberOnboardingDoor } from '@/utils/onboardingEntry'

import styles from './LandingNav.module.scss'

/**
 * The platform's own header system, matched rather than approximated: the gradient mark, a BLACK
 * "Intch" wordmark, and the product name in the small slate tagline slot beside it — the slot where
 * the platform itself says "Future of Work App". An earlier header made "Intch" purple and welded
 * the product name into the wordmark, which read as a different company's logo.
 *
 * The header sheds its extras rather than wrapping: the hero repeats both CTAs one screen below.
 */
export const LandingNav = ({ onBookDemo }: { onBookDemo: () => void }) => {
  const { t } = useTranslation()

  return (
    <nav className={styles.root}>
      <Link className={styles.logo} to={Routes.landing} aria-label="Intch Connect">
        <BrandMark nameClassName={styles.productName} />
      </Link>

      <div className={styles.spacer} />

      <a className={styles.navLink} href="#features">
        {t('landing.nav.howItWorks')}
      </a>
      {/* A form, not a mailto: "contact sales" asks the reader to compose an email, and the four
          answers we actually need are the ones that make the first call useful. */}
      <button type="button" className={`${styles.button} ${styles.buttonWhite}`} onClick={onBookDemo}>
        {t('landing.nav.bookDemo')}
      </button>
      <Link
        className={`${styles.button} ${styles.buttonPrimary}`}
        to={Routes.onboard}
        onClick={() => rememberOnboardingDoor('nav')}
      >
        {t('landing.cta.primary')}
      </Link>
    </nav>
  )
}
